const qrCode = () => import('@/views/qrCode/Index')
const preview = () => import('@/views/qrCode/FilePreview')

export default [
  {
    path: '/qrcode',
    component: qrCode,
    name: 'qrcode',
    meta: {
      title: '行程预览'
    }
  },
  {
    path: '/qrcode/preview',
    component: preview,
    name: 'preview',
    meta: {
      title: '行程预览'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/qrCode.js